<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-map-marker"
    ></vuse-section-definition>

    <v-row class="fill-width">
      <v-col cols="8" sm="8">
        <v-row class="mx-3">
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
              background-color="#EDF2F7"
              filled
              v-model="search.name"
              label="Tên"
              placeholder="Nhập tên"
              @input="debounceInput"
            ></v-text-field>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
                background-color="#EDF2F7"
                filled
                v-model="search.hotline"
                label="Phone"
                placeholder="Nhập Phone"
                @keyup="debounceInput"
            ></v-text-field>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
                background-color="#EDF2F7"
                filled
                v-model="search.email"
                label="Email"
                placeholder="Nhập Email"
                @keyup="debounceInput"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4" sm="4" align="right">
        <v-btn color="primary" align="right" @click="openDialog" v-if="hasPermissions('Create support')">
          Thêm
        </v-btn>
      </v-col>
    </v-row>


    <v-container fluid class="content_product1 rounded-lg">

      <v-row justify="center" align="center">
        <!-- <v-col cols="12" align="right">
          <v-btn
              class="mr-16"
              color="primary"
              align="right"
              @click="openDialog"
          >
            Thêm
          </v-btn>
        </v-col> -->
        <v-col cols="12" >
          <v-data-table
              :headers="headers"
              :items="dataResult"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item.id)" v-if="hasPermissions('Update support')">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)" v-if="hasPermissions('Delete support')">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
        v-model="dialog"
        max-width="500"
        persistent
    >
      <v-card class="rounded-lg">
        <v-card-title class="d-flex justify-center">
          Thêm cửa hàng trưởng
        </v-card-title>

        <v-card-text>
          <v-row class="mt-5">
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Họ tên"
                  v-model="fullname"
                  placeholder="Nhập họ tên"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Hotline"
                  v-model="hotline"
                  placeholder="Nhập Hotline"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Email"
                  v-model="email"
                  placeholder="Nhập email"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                  hide-details
                  filled
                  class="width-input mt-3"
                  v-model="store_id"
                  :items="stores"
                  item-text="name"
                  item-value="id"
                  clearable
                  label="Showroom"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-file-input
                  label="Ảnh đại diện"
                  placeholder="Tải ảnh lên"
                  prepend-icon="mdi-camera"
                  @change="fileSelected"
              ></v-file-input>
              <v-img v-if="src"
                  :src="src" width="200" height="200"
              ></v-img>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="6" class="d-flex justify-end">
                  <v-btn
                      @click="dialog = false"
                  >
                    Hủy
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn v-if="is_edit"
                      color="primary"
                      @click="update"
                  >
                    Lưu
                  </v-btn>
                  <v-btn
                      v-else
                      color="primary"
                      @click="addNew"
                  >
                    Lưu
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {GET_LIST_SUPPORT, SAVE_SUPPORT, GET_DETAIL_SUPPORT, SET_DETAIL_SUPPORT, UPDATE_SUPPORT, DELETE_SUPPORT, UPLOAD_AVATAR_SUPPORT, GET_DATA_SEARCH} from '@/store/modules/support';
import {GET_LIST_SHOWROOM} from "@/store/modules/showroom";
import {mapGetters} from 'vuex';
import {debounce} from "debounce";
export default {
  data() {
    return {
      fullname:'',
      email:'',
      phone:'',
      photo_url:'',
      hotline:'',
      store_id:null,
      dialog:false,
      page: "Quản lý showroom",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Quản lý cửa hàng trưởng",
          disabled: true,
        },
      ],
      headers: [
        { text: 'ID', value: 'id', align: 'start', },
        {
          text: 'Tên',
          sortable: false,
          value: 'fullname',
        },
        { text: 'Hotline', value: 'hotline' },
        { text: 'Email', value: 'email' },
        { text: 'showroom', value: 'store_name' },
        { text: 'Actions', value: 'actions' },
      ],
      search: {
        name: "",
        hotline: "",
        email: "",
        limit: 10,
      },
      is_edit:false,
      image: {},
      src:''
    };
  },
  computed:{
    ...mapGetters({
      // supports: 'supports',
      support: 'support',
      dataResult: "dataSearchSupport",
      stores: "showrooms"
    })
  },
  watch:{
    support(val){
      if (val && val.id) {
        this.fullname = val.fullname;
        this.hotline = val.hotline;
        this.email = val.email;
        this.src = val.photo_url_path;
        this.store_id = val.store_id;
      }
    }
  },
  async created() {
    this.search.name =  this.$route.query.name || ''
    this.search.hotline = this.$route.query.hotline || ''
    this.search.email = this.$route.query.email || ''
    this.params();
    await this.$store.dispatch(`${GET_LIST_SUPPORT}`);
    await this.$store.dispatch(`${GET_LIST_SHOWROOM}`);
  },

  methods:{
    fileSelected(event) {
      const _this = this;
      if (!event) {
        this.photo_url = '';
        this.src= '';
      } else {
        this.image = event;
        this.src = URL.createObjectURL(this.image);
        let formData = new FormData();
        formData.append("upload", this.image);
        formData.append("type", "supports");
        this.$store.dispatch(`${UPLOAD_AVATAR_SUPPORT}`, formData).then((data) => {
          if (data && data.data && data.data.data) {
            data.data.data.forEach(element => {
              _this.photo_url = element.path;
            })
          }
        })
      }
    },
    async editItem(id){
      await this.$store.dispatch(`${GET_DETAIL_SUPPORT}`, id)
      this.dialog = true;
      this.is_edit = true;
    },
    deleteItem(id){
      confirm('Bạn có chắc muốn xóa?') &&
      this.$store.dispatch(`${DELETE_SUPPORT}`,id).then(data=>{
        if(data && data.status === 1) {
          this.$store.dispatch(GET_LIST_SUPPORT);
        }
      })
    },
    async addNew() {
      const _this = this;
      let data_support = {
        fullname: this.fullname,
        hotline: this.hotline,
        email: this.email,
        photo_url: this.photo_url,
        store_id: this.store_id
      }
      await this.$store.dispatch(`${SAVE_SUPPORT}`,data_support).then((data)=>{
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          _this.$store.dispatch(`${GET_LIST_SUPPORT}`);
          _this.dialog = false;
          _this.src = ''
        }else{
          alert(data.data.errors)
        }
      })
    },
    async update() {
      const _this = this;
      let data_support = {
        id: this.support.id,
        fullname: this.fullname,
        hotline: this.hotline,
        email: this.email,
        photo_url: this.photo_url,
        store_id: this.store_id
      }
      await this.$store.dispatch(`${UPDATE_SUPPORT}`,data_support).then((data)=>{
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          _this.$store.dispatch(`${GET_DATA_SEARCH}`);
          _this.dialog = false;
          _this.src = ''
        }else{
          alert(data.data.errors)
        }
      })
    },
    async openDialog(){
      this.fullname = '';
      this.hotline = '';
      this.email = '';
      this.src = '';
      this.store_id = '';
      this.dialog = true;
      this.is_edit = false;
      await this.$store.commit(`${SET_DETAIL_SUPPORT}`, {})
    },
    
    replaceSupport() {
      this.$router.replace({
        query: {
          name: this.search.keyword_name,
          slug: this.search.slug,
          brand_id: this.search.brand_id != "-1" ? this.search.brand_id : null,
          page_current: parseInt(this.page_number),
        }
      })
    },
    params() {
      let param = {
        name: this.search.name,
        hotline: this.search.hotline,
        email: this.search.email,
      };
      this.$store.dispatch(GET_DATA_SEARCH, param);
    },
    debounceInput: debounce(function (e) {
      this.search.keyword_name = e;
      this.params();
      this.replaceSupport();
    }, 200),
  }
};
</script>
<style lang="scss">
.content_product1 {
  background: #ffffff !important;

}
</style>
